<template>

    <div class="menu-list" @mouseleave="handleLeave($event)">
        <div v-for="event in currentMenu" :key="event.name"
             class="menu-list-item line" >
          <a @click="handleClick(event)">
            <i class="el-icon-arrow-left" v-if="event.child"></i></a>
          <a @click="handleClick(event)"
             @mouseover="handleHover(event)"
             type="text" :class="globalTransition">
            {{$t(menuName + '.'+event.name)}}
          </a></div>
    </div>

</template>

<script>
export default {
  name: 'menuList',
  props: {
    menuName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mainMenu: [
        { name: 'homePage', root: '/', route: '/', child: false },
        { name: 'about', root: 'about', route: 'about', child: 'about' },
        { name: 't$e', root: 't$e', route: 't$e', child: 't$e' },
        { name: 'p$s', root: 'p$s', route: 'p$s', child: 'p$s' },
        { name: 'contact', root: 'contact', route: 'contact', child: false },
      ],
      about: [
        { name: 'aboutDIMER', root: 'about', route: 'aboutDetailPage', child: false },
        { name: 'DIMER_BOARD', root: 'about', route: 'aboutBoardPage', child: false },
        /*{ name: 'm$c', root: 'about', route: 'aboutCommitteePage', child: false },*/
         { name: 'a$r', root: 'about', route: 'aboutAwardPage', child: false },
        { name: 'latestNews', root: 'about', route: 'aboutDetailPage', child: false },
      ],
      t$e: [
        { name: 'gasProcessTech', root: 't$e', route: 'gasProcessTech', child: false },
        { name: 'ptgTech', root: 't$e', route: 'ptgTech', child: false },
        { name: 'cleanEnergyDev', root: 't$e', route: 'cleanEnergyDev', child: false },
      ],
      p$s: [
        { name: 'h2ch4Rec$co2Capt', root: 'p$s', route: '1h2ch4Rec$co2Capt', child: false },
        { name: 'renewablePower', root: 'p$s', route: '2renewablePower', child: false },
        { name: 'co2Sep$Capt', root: 'p$s', route: '3co2Sep$Capt', child: false },
        { name: 'co2Capt$reuse', root: 'p$s', route: '4co2Capt$reuse', child: false },
        { name: 'wasteWaterTreat', root: 'p$s', route: '5wasteWaterTreat', child: false },
      ],
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
    currentMenu() {
      return this[this.menuName];
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
  },
  methods: {
    handleClick(event) {
      if (event.child) {
        this.$emit('close-second-menu');
        this.$emit('menu-click');
        this.$router.push({
          path: event.root,
        });
      } else {
        this.$emit('close-second-menu');
        this.$emit('menu-click');
        this.$router.push({
          path: event.root,
          query: {
            anchor: event.route,
          },
        });
      }
    },
    handleHover(event) {
      if (event.child) {
        this.$emit('open-second-menu', event.child);
      }
    },
    handleLeave(event) {
      const outWidth = event.clientX;
      const currentWidth = this.$el.parentElement.parentElement.offsetLeft;
      if (this.menuName !== 'mainMenu' && outWidth < currentWidth) {
        this.$emit('close-second-menu');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-list{
  background-color: #1a1a1a;
  color: #fff;
  padding: 150px 40px 0px 30px;
  font-size: 1.4rem;
  border-left: #bfcbd9 solid 2px;
}
  .menu-list-item{
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    white-space: nowrap;
  }
  .line:hover{
    a{text-decoration:underline}
  }
</style>



// WEBPACK FOOTER //
// src/components/menuList/index.vue